export class RolType {
  ROLE_USER = 'role_user';
  ROLE_ADMIN = 'role_admin';
  ROLE_SUPERADMIN = 'role_superadmin';
  ROLE_DAPDA = 'role_dapda';
  ROLE_ALL = 'role_all';
  ROLE_BDC = 'role_bdc';
}
